export default "__VITE_ASSET__f75956f2__"